import useFetch from 'elements/Hooks/useFetch'
import React from 'react'
import RFQ from '../../../components/Purchasing/RFQ/RFQ'
import useListCompanyFilter from '../../../elements/Hooks/useListCompanyFilter'
import useTitle from '../../../elements/Hooks/useTitle'

export default function RFQCont() {
  const select = '_id,_key,code,enquiry,date,vendor,title,issuance,status,file'
  const { data, fetching, fetch } = useFetch({
    url: `rfq/?select=${select}`,
    queryKey: 'rfq',
  })
  const { list, company, onChangeCompany } = useListCompanyFilter(data, fetching)
  useTitle('RFQ')

  return (
    <RFQ
      {...{
        list,
        fetching,
        fetch,
        company,
        onChangeCompany,
      }}
    />
  )
}
